module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (this.$store.state.auth.loggedIn) ? _c('div', {
    staticClass: "loggedInAnimation"
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Sign in with any of your linked accounts")]), _vm._v(" "), _c('tabs', {
    attrs: {
      "layout": "left",
      "animation": "fade",
      "only-fade": false
    }
  }, _vm._l((_vm.signInProviderTabs), function(item) {
    return _c('tab-pane', {
      key: item.label,
      staticClass: "signInTabPane",
      attrs: {
        "label": item.label,
        "icon": 'fa fa-' + item.icon
      }
    }, [_c('div', {
      staticClass: "padded-box"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('transition', {
      attrs: {
        "name": "scaleFade",
        "mode": "out-in"
      }
    }, [(!_vm.authUI.loginBtnDisabled) ? _c('p', {
      staticClass: "card-header-title"
    }, [_vm._v(_vm._s(item.desc))]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "scaleFade",
        "mode": "out-in"
      }
    }, [(_vm.authUI.loginBtnDisabled) ? _c('p', {
      staticClass: "card-header-title"
    }, [_vm._v("You're signed in.")]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "scaleFade",
        "mode": "out-in",
        "appear": ""
      }
    }, [(item.type === 'form' && !_vm.authUI.loginBtnDisabled) ? _c('div', {
      staticClass: "card-content"
    }, [_c('user-pass-form')], 1) : _vm._e()]), _vm._v(" "), (item.type === 'button' && !_vm.authUI.loginBtnDisabled) ? _c('div', {
      staticClass: "card-footer"
    }, [_c('a', {
      staticClass: "card-footer-item",
      class: {
        'is-loading': _vm.authUI.pending
      },
      attrs: {
        "disabled": _vm.authUI.loginBtnDisabled,
        "id": "quickstart-sign-in"
      },
      on: {
        "click": function($event) {
          return _vm.signIn(item.icon)
        }
      }
    }, [_c('i', {
      class: 'fa fa-pull-left fa-' + item.icon
    }), _vm._v(" Sign in\n                    ")])]) : _vm._e()], 1)])])
  }), 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e1e6012"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/LoginFirebase.vue
// module id = 144
// module chunks = 14